import React, { useEffect, useState } from "react";
import "./Profile.css";
import { useChange2FAStatus } from "./api";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";

export default function TwoFactorAuthSetting({
  currentState,
}: {
  currentState?: boolean;
}) {
  const [toggled, setToggled] = useState(currentState || false);
  const [serverError, setServerError] = useState("");
  const change2FAStatusMutation = useChange2FAStatus();

  const queryClient = useQueryClient();

  const onSubmit = (currentState: boolean) => {
    setServerError("");

    if (!navigator.onLine) {
      toast.error("No internet connection. Please check your network.");
      return;
    }

    change2FAStatusMutation.mutate(currentState, {
      onSuccess: (data: any) => {
        const status = data.user.is_2fa_enabled ? "enabled" : "disabled";
        toast.success(
          `Two-factor authentication has been ${status}.`,
          {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: true,
          }
        );
        queryClient.invalidateQueries({ queryKey: ["get-user-info"] });
      },
      onError: (error: any) => {
        setServerError(
          error.response?.data?.message ||
            "An error occurred while updating 2FA status"
        );
      },
    });
  };

  useEffect(() => {
    if (serverError) {
      toast.error(serverError);
    }
  }, [serverError]);

  return (
    <div className='flex flex-col w-4/5 sm:w-4/5 lg:w-2/3 m-4'>
      <div className='bg-white flex flex-col p-4 rounded-t-md'>
        <h1 className='text-xl font-bold'>Two Factor Authentication</h1>
        <p className='text-xs md:text-sm font-light mt-4 mb-3'>
          Manage two-factor authentication (2FA) for your account. When enabled,
          you’ll receive a one-time verification code at each login. Turning off
          2FA removes this extra layer of security, so consider your security
          needs before making this change.
        </p>
        <div className='flex items-center space-x-2'>
          <button
            className={`toggle-btn ${toggled ? "toggled" : ""}`}
            onClick={() => setToggled(!toggled)}
          >
            <div className='thumb'></div>
          </button>
          {toggled ? (
            <p className='text-sm'>Enabled</p>
          ) : (
            <p className='text-sm'>Disabled</p>
          )}
        </div>
      </div>
      <div className='flex justify-end bg-[#D9D9D9] w-full rounded-b-md px-3 py-2'>
        <button
          className='bg-[#0275D8] text-xs text-white rounded-md px-3 py-2 hover:bg-[#0256A1]'
          onClick={() => onSubmit(toggled)}
        >
          Save
        </button>
      </div>
    </div>
  );
}
